import { App, DirectiveBinding } from 'vue';
const list = ['test'];
const permission = {
    beforeMount: (el: HTMLElement, binding: DirectiveBinding) => {
        try {
            if (list.includes(binding.value)) {
                console.log('binding.value', binding.value)
            } else {
                el && (el.style.display = 'none');
            }
        } catch (e) {
            console.log(e);
        }
        return true;
    }
}
const directivesList: { [propName: string]: any } = {
    permission
}
const directives = {
    install: (app: App<Element>) => {
        try {
            Object.keys(directivesList).forEach(key => {
                app.directive(key, directivesList[key]);
            })
        } catch (e) {
            console.log(e);
        }
    }
}
export default directives;